var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header-index-wide"},[_c('a-card',{staticStyle:{"width":"100%","height":"100vh","display":"flex","justify-content":"center","align-items":"center"}},[_c('h1',{staticStyle:{"font-size":"90px"}},[_vm._v("Welcome to CORE SYSTEM !")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }